import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  pulses = 'pulses',
  pulse = 'pulse',
}

enum ExternalRoutesIds {
  chat = 'chat',
  pulsesPage = 'pulsesPage',
}

export const pulsesRouteRef = createRouteRef({ id: RoutesIds.pulses });

export const rootRouteRef = pulsesRouteRef;

export const pulseRouteRef = createSubRouteRef({
  id: RoutesIds.pulse,
  parent: rootRouteRef,
  path: '/:id',
});

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

export const Routes = {
  pulses: pulsesRouteRef,
  pulse: pulseRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const pulsesPageRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.pulsesPage,
  optional: true,
});

export const ExternalRoutes = {
  chat: chatRouteRef,
  pulsesPage: pulsesPageRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
